// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + "vendors--web-vitals.js" + "." + "17da6f2f" + ".js";
};